var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCopyGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.57895 0H1.47368C0.663158 0 0 0.654545 0 1.45455V10.9091C0 11.3091 0.331579 11.6364 0.736842 11.6364C1.14211 11.6364 1.47368 11.3091 1.47368 10.9091V2.18182C1.47368 1.78182 1.80526 1.45455 2.21053 1.45455H9.57895C9.98421 1.45455 10.3158 1.12727 10.3158 0.727273C10.3158 0.327273 9.98421 0 9.57895 0ZM12.5263 2.90909H4.42105C3.61053 2.90909 2.94737 3.56364 2.94737 4.36364V14.5455C2.94737 15.3455 3.61053 16 4.42105 16H12.5263C13.3368 16 14 15.3455 14 14.5455V4.36364C14 3.56364 13.3368 2.90909 12.5263 2.90909ZM11.7895 14.5455H5.15789C4.75263 14.5455 4.42105 14.2182 4.42105 13.8182V5.09091C4.42105 4.69091 4.75263 4.36364 5.15789 4.36364H11.7895C12.1947 4.36364 12.5263 4.69091 12.5263 5.09091V13.8182C12.5263 14.2182 12.1947 14.5455 11.7895 14.5455Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopyGrey);
export default __webpack_public_path__ + "static/media/icon-copy--grey.e8281926524149c4d62147c21db83ad6.svg";
export { ForwardRef as ReactComponent };